import * as React from 'react'
import { IOption, IProviderProps } from '@user/components/Filters'
import { useAppDispatch } from '@user/store/hooks/useAppDispatch'
import { useAppSelector } from '@user/store/hooks/useAppSelector'
import { getAllKnockStatuses } from '@user/store/knockStatus/api'
import {
  knockStatusesToOptions,
  selectAllKnockStatuses,
  selectKnockStatusesLoaded,
} from '@user/store/knockStatus'

export const KnockStatusFilter: React.FC<IProviderProps> = ({ render }) => {
  const dispatch = useAppDispatch()
  const knockStatuses = useAppSelector(selectAllKnockStatuses)
  const loaded = useAppSelector(selectKnockStatusesLoaded)

  // Read the knock-status catalog from the store rather than a separate cache,
  // so a rename or delete in Settings/D2D is reflected here immediately
  // (WWM-17972). Only fetch when nothing has populated the slice yet.
  React.useEffect(() => {
    if (loaded) return
    dispatch(getAllKnockStatuses())
  }, [loaded, dispatch])

  const options = React.useMemo<IOption[]>(
    () => knockStatusesToOptions(knockStatuses),
    [knockStatuses],
  )

  return <>{render(options, !loaded)}</>
}
KnockStatusFilter.displayName = 'KnockStatusFilter'
